import React from 'react'
import {
    Table, Container,
    Row, Col,
    Label, Input, Button,
    Collapse,
} from 'reactstrap'
import {
    getAllAddons,
} from '../model/request/addons'
import {
    getTypes,
} from '../model/request/quotes'
import {
    getAssignTo,
    getSortedAssignTo,
} from '../model/request/schedule'
import { TextNormalization } from '../model/TextNormalization'
import {
    getAllScheduleTemplates,
    insertScheduleTemplate,
    updateScheduleTemplate,
    deleteScheduleTemplate,
} from '../model/request/schedule_template'
import {
    getAllScheduleMaterialTemplates,
    insertScheduleMaterialTemplate,
    updateScheduleMaterialTemplate,
    deleteScheduleMaterialTemplate,
} from '../model/request/schedule_material_template'
import {
    AddonWithOptions,
    SignType,
} from '../model/Sign'
import {
    Priority,
} from '../model/Schedule'
import {
    ScheduleTemplate,
} from '../model/ScheduleTemplate'
import {
    EQUIPMENT_LIST,
    EQUIPMENT_PROCESSES,
} from '../model/Equipment'
import {
    THICKNESS_VALUES,
    MATERIAL_VALUES,
} from '../model/Materials'
import {
    AlertModalModel
} from './modal/AlertModalController'
import SimpleDropdown from '../view/DropDownView'
import {
    IoIosArrowUp,
    IoIosArrowDown,
} from 'react-icons/io'
import ScheduleTemplateFlowView from './ScheduleTemplateFlowView'

const PRIORITY_VALUES = Object.entries(Priority).map(item => item[0]).reverse()

class ScheduleTemplateBuilderViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'types': [],
            'addons': [],
            'templates': [],
            'materialTemplates': [],
            'assign_to': [],
            'expandedTemplates': [],
            'expandedMaterialTemplates': [],
            'minimizeTypes': [],
            'openFlowCharts': [],
            'bulkEquip': '',
            'bulkProcess': 'All',
            'bulkFormula': '',
        }
    }

    componentDidMount() {
        this.props.turnOnLoader(5)

        getTypes().then(
            (result) => {
                this.setState({
                    'types': result.data.types.map(SignType.from),
                })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )

        getAllAddons().then(
            (result) => {
                this.setState({
                    'addons': result.data.addons.map(AddonWithOptions.from),
                })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )

        getAllScheduleTemplates().then(
            (result) => {
                this.setState({
                    'templates': result.data.templates.map(ScheduleTemplate.from),
                })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )

        getAssignTo().then(
            (result) => {
                this.setState({ 'assign_to': result.data.assign_to })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )

        getAllScheduleMaterialTemplates().then(
            (result) => {
                this.setState({ 'materialTemplates': result.data.templates })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )
    }

    // MARK: Material Template CRUD

    postMaterialTemplate(mt) {
        this.props.turnOnLoader()
        insertScheduleMaterialTemplate(mt).then(
            (result) => {
                const saved = result.data.template
                this.setState((s) => ({
                    'materialTemplates': [...s.materialTemplates.filter(x => x !== mt), saved],
                }))
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )
    }

    saveMaterialTemplate(mt) {
        this.props.turnOnLoader()
        updateScheduleMaterialTemplate(mt).then(
            () => this.props.turnOffLoader(),
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )
    }

    deleteMaterialTemplate(mt) {
        this.props.showAlertModal((new AlertModalModel())
            .setTitle('Are you sure?')
            .setBody('Delete this material config?')
            .addConfirmButton(() => {
                this.props.turnOnLoader()
                deleteScheduleMaterialTemplate(mt.id).then(
                    () => {
                        this.setState((s) => ({ 'materialTemplates': s.materialTemplates.filter(x => x !== mt) }))
                        this.props.turnOffLoader()
                    },
                    (error) => { this.props.showError(error); this.props.turnOffLoader() }
                )
            })
            .addCancelButton(() => this.props.closeModal())
        )
    }

    swapMaterialTemplates(typeMTs, indexA, indexB) {
        typeMTs.forEach((t, i) => { t.order_index = i })
        const tmp = typeMTs[indexA]
        typeMTs[indexA] = typeMTs[indexB]
        typeMTs[indexB] = tmp
        typeMTs[indexA].order_index = indexA
        typeMTs[indexB].order_index = indexB
        this.saveMaterialTemplate(typeMTs[indexA])
        this.saveMaterialTemplate(typeMTs[indexB])
        this.setState({})
    }

    // MARK: Template CRUD

    postTemplate(template) {
        this.props.turnOnLoader()
        insertScheduleTemplate(template).then(
            (result) => {
                const saved = ScheduleTemplate.from(result.data.result)
                this.setState((state) => ({
                    'templates': [...state.templates.filter(t => t !== template), saved],
                    'expandedTemplates': [...state.expandedTemplates.filter(t => t !== template), saved],
                }))
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )
    }

    updateTemplate(template) {
        this.props.turnOnLoader()
        updateScheduleTemplate(template).then(
            () => this.props.turnOffLoader(),
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )
    }

    swapTemplates(typeTemplates, indexA, indexB) {
        typeTemplates.forEach((t, i) => { t.order_index = i })
        const tmp = typeTemplates[indexA]
        typeTemplates[indexA] = typeTemplates[indexB]
        typeTemplates[indexB] = tmp
        typeTemplates[indexA].order_index = indexA
        typeTemplates[indexB].order_index = indexB
        this.updateTemplate(typeTemplates[indexA])
        this.updateTemplate(typeTemplates[indexB])
        this.setState({})
    }

    deleteTemplate(template) {
        this.props.showAlertModal((new AlertModalModel())
            .setTitle('Are you sure?')
            .setMessage('Delete template: "' + (template.short_description || '(unnamed)') + '"?')
            .addYesButton(() => {
                this.props.closeModal()
                this.props.turnOnLoader()
                deleteScheduleTemplate(template.id).then(
                    () => {
                        this.setState((state) => ({
                            'templates': state.templates.filter(t => t !== template),
                            'expandedTemplates': state.expandedTemplates.filter(t => t !== template),
                        }))
                        this.props.turnOffLoader()
                    },
                    (error) => { this.props.showError(error); this.props.turnOffLoader() }
                )
            })
            .addCancelButton(() => this.props.closeModal())
        )
    }

    // MARK: Render helpers

    /**
     * @param {string} title
     * @param {string} value
     * @param {[string]} values
     * @param {function} onChange
     * @param {{normalize: string}} modalOptions forwarded to
     *     `showTextFieldModal` when 'Other' is picked - see its docs.
     */
    renderDropDown(title, value, values, onChange, modalOptions={}) {
        // Where 'Other' sits in the caller's list, captured before the
        // append below shifts it off the last slot.
        const lastIndex = values.length - 1

        let index = values.indexOf(value)
        if (index === -1 && value && value.length > 0) {
            values = [...values, value]
            index = values.length - 1
        }
        return <SimpleDropdown
            index={index}
            values={values}
            onChange={(i) => {
                if (i === lastIndex && values[i] === 'Other') {
                    this.props.showTextFieldModal(title, (val) => onChange(val), value, modalOptions)
                } else {
                    onChange(values[i])
                }
            }}
        />
    }

    addonDropdownLabel(addon) {
        const suffix = addon.options.map(g => g[0]?.label || '').filter(l => l).join(' ')
        return suffix ? addon.cost_label + ' - ' + suffix : addon.cost_label
    }

    // Enumerate every possible label for an addon by iterating all pick combinations.
    // Uses a mixed-radix counter — each digit represents the selected index in one option group.
    addonOptionGroups(addon) {
        if (!addon || !addon.options || addon.options.length === 0) return []
        const groupSizes = addon.options.map(g => g.length)
        const picks = new Array(groupSizes.length).fill(0)
        const labels = []

        do {
            const signAddon = addon.toSignAddon([...picks])
            labels.push(signAddon.label)

            // Increment the counter from the rightmost digit
            let pos = picks.length - 1
            while (pos >= 0) {
                picks[pos]++
                if (picks[pos] < groupSizes[pos]) break
                picks[pos] = 0
                pos--
            }
        } while (picks.some(p => p !== 0))

        return labels
    }

    renderTemplate(template, typeAddons, typeTemplates, index) {
        const isExpanded = this.state.expandedTemplates.includes(template)
        const savedTypeTemplates = typeTemplates.filter(t => t !== template && !t.is_local)
        const priorityLabel = Object.entries(Priority).find(([k, v]) => v === template.priority)?.[0] || 'Medium'

        const update = () => this.setState({})

        return <React.Fragment key={template.id || template._local_key}>
            <tr>
                <td style={{ 'width': '40%' }}>
                    <Input
                        value={template.short_description}
                        placeholder="Short description"
                        onChange={(e) => { template.short_description = e.target.value; update() }}
                    />
                </td>
                <td>
                    <Button onClick={() => {
                        if (isExpanded) {
                            this.setState((s) => ({ 'expandedTemplates': s.expandedTemplates.filter(t => t !== template) }))
                        } else {
                            this.setState((s) => ({ 'expandedTemplates': [...s.expandedTemplates, template] }))
                        }
                    }}>
                        {isExpanded
                            ? <IoIosArrowDown style={{ 'fontSize': '20pt' }} />
                            : <IoIosArrowUp style={{ 'fontSize': '20pt' }} />
                        }
                    </Button>
                </td>
                <td>
                    {template.is_local
                        ? <Button color="success" onClick={() => this.postTemplate(template)}>Save New</Button>
                        : <Button color="success" onClick={() => this.updateTemplate(template)}>Update</Button>
                    }
                </td>
                <td>
                    <Button className="btn btn-copy" onClick={() => {
                        const copy = ScheduleTemplate.from(JSON.parse(JSON.stringify(template)))
                        copy.id = ''
                        copy.is_local = true
                        copy._local_key = Date.now() + Math.random()
                        copy.order_index = typeTemplates.reduce((max, t) => Math.max(max, t.order_index || 0), -1) + 1
                        this.setState((s) => ({
                            'templates': [...s.templates, copy],
                            'expandedTemplates': [...s.expandedTemplates, copy],
                        }))
                    }}>Copy</Button>
                </td>
                <td>
                    <Button color="danger" disabled={!!template.is_local} onClick={() => this.deleteTemplate(template)}>
                        Delete
                    </Button>
                </td>
                <td>
                    <div style={{ 'display': 'flex', 'flexDirection': 'column', 'gap': '2px' }}>
                        <Button size="sm" disabled={!template.id || index === 0}
                            onClick={() => this.swapTemplates(typeTemplates, index, index - 1)}>
                            <IoIosArrowUp style={{ 'fontSize': '10pt' }} />
                        </Button>
                        <Button size="sm" disabled={!template.id || index === typeTemplates.length - 1 || !typeTemplates[index + 1]?.id}
                            onClick={() => this.swapTemplates(typeTemplates, index, index + 1)}>
                            <IoIosArrowDown style={{ 'fontSize': '10pt' }} />
                        </Button>
                    </div>
                </td>
            </tr>
            {isExpanded && <tr>
                <td colSpan="6" style={{ 'padding': '0 12px 16px 32px' }}>
                    <Table size="sm" borderless style={{ 'tableLayout': 'fixed' }}>
                        <colgroup>
                            <col style={{ 'width': '100px' }} />
                            <col />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td><Label>Thickness</Label></td>
                                <td>{this.renderDropDown('Thickness', template.thickness, THICKNESS_VALUES, (v) => { template.thickness = v; update() })}</td>
                            </tr>
                            <tr>
                                <td><Label>Material</Label></td>
                                <td>{this.renderDropDown('Material', template.material, MATERIAL_VALUES, (v) => { template.material = v; update() })}</td>
                            </tr>
                            <tr>
                                <td><Label>Equip</Label></td>
                                <td>{this.renderDropDown('Equip', template.equip, EQUIPMENT_LIST, (v) => { template.equip = v; template.process = ''; update() })}</td>
                            </tr>
                            <tr>
                                <td><Label>Process</Label></td>
                                <td>{this.renderDropDown('Process', template.process, EQUIPMENT_PROCESSES[template.equip] || ['Other'], (v) => { template.process = v; update() })}</td>
                            </tr>
                            <tr>
                                <td><Label>Priority</Label></td>
                                <td>{this.renderDropDown('Priority', priorityLabel, PRIORITY_VALUES, (v) => { template.priority = Priority[v]; update() })}</td>
                            </tr>
                            <tr>
                                <td><Label>Assign To</Label></td>
                                <td>{this.renderDropDown('Assignee', template.assign_to, [...getSortedAssignTo(this.state.assign_to, template.equip), 'Other'], (v) => { template.assign_to = v; update() }, {normalize: TextNormalization.Whitespace})}</td>
                            </tr>
                            <tr>
                                <td><Label>Time Formula (Hours)</Label></td>
                                <td>
                                    <Input
                                        value={template.time_formula}
                                        placeholder="e.g. ((width*2 + height*2) * 30 + 60*3) * quantity"
                                        onChange={(e) => { template.time_formula = e.target.value; update() }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><Label>Premature Release</Label></td>
                                <td>
                                    <Input type="checkbox" checked={template.premature_release}
                                        onChange={() => { template.premature_release = !template.premature_release; update() }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td valign="top"><Label>Addon Logic</Label></td>
                                <td>
                                    <small style={{ 'color': '#888', 'display': 'block', 'marginBottom': '8px' }}>
                                        Empty = type-level (matches all signs). Outer groups are OR; conditions within a group are AND.
                                    </small>
                                    {(template.addon_logic || []).map((clause, ci) => (
                                        <React.Fragment key={ci}>
                                        {ci > 0 && <div style={{ 'textAlign': 'center', 'color': '#888', 'margin': '4px 0', 'fontSize': '0.85em', 'fontWeight': '600' }}>OR</div>}
                                        <div style={{ 'border': '1px solid #ccc', 'borderRadius': '4px', 'padding': '8px', 'marginBottom': '8px' }}>
                                            <div style={{ 'display': 'flex', 'justifyContent': 'space-between', 'alignItems': 'center', 'marginBottom': '6px' }}>
                                                <small style={{ 'fontWeight': '600' }}>AND Group {ci + 1}</small>
                                                <button type="button"
                                                    onClick={() => { template.addon_logic = template.addon_logic.filter((_, j) => j !== ci); update() }}
                                                    style={{ 'background': 'none', 'border': 'none', 'cursor': 'pointer', 'color': 'inherit' }}
                                                >×</button>
                                            </div>
                                            {clause.map((literal, li) => {
                                                const addon = typeAddons.find(a => a.id === literal.addon_id)
                                                const availLabels = this.addonOptionGroups(addon)
                                                return <div key={li} style={{ 'marginBottom': '8px', 'paddingLeft': '8px', 'borderLeft': '2px solid #eee' }}>
                                                    <div style={{ 'display': 'flex', 'alignItems': 'center', 'gap': '8px', 'marginBottom': '4px' }}>
                                                        <Label check style={{ 'margin': 0, 'cursor': 'pointer', 'whiteSpace': 'nowrap' }}>
                                                            <Input type="checkbox" checked={!!literal.is_not}
                                                                onChange={() => { literal.is_not = !literal.is_not; update() }}
                                                            />{' '}NOT
                                                        </Label>
                                                        <Input type="select" value={literal.addon_id || ''}
                                                            onChange={(e) => { literal.addon_id = e.target.value || null; literal.labels = []; update() }}
                                                        >
                                                            <option value="">Select addon…</option>
                                                            {typeAddons.map(a => <option key={a.id} value={a.id}>{this.addonDropdownLabel(a)}</option>)}
                                                        </Input>
                                                        <button type="button"
                                                            onClick={() => { clause.splice(li, 1); if (clause.length === 0) template.addon_logic = template.addon_logic.filter((_, j) => j !== ci); update() }}
                                                            style={{ 'background': 'none', 'border': 'none', 'cursor': 'pointer', 'color': 'inherit', 'flexShrink': 0 }}
                                                        >×</button>
                                                    </div>
                                                    {availLabels.length > 0 && <div style={{ 'paddingLeft': '8px' }}>
                                                        <small style={{ 'color': '#888' }}>Labels (empty = any):</small>
                                                        {availLabels.map(label => (
                                                            <Label key={label} check style={{ 'display': 'block', 'cursor': 'pointer' }}>
                                                                <Input type="checkbox"
                                                                    checked={(literal.labels || []).includes(label)}
                                                                    onChange={() => {
                                                                        literal.labels = (literal.labels || []).includes(label)
                                                                            ? literal.labels.filter(l => l !== label)
                                                                            : [...(literal.labels || []), label]
                                                                        update()
                                                                    }}
                                                                />{' '}{label}
                                                            </Label>
                                                        ))}
                                                    </div>}
                                                </div>
                                            })}
                                            <Button size="sm" color="secondary"
                                                onClick={() => { clause.push({ addon_id: null, labels: [], is_not: false }); update() }}
                                            >+ Add Condition</Button>
                                        </div>
                                        </React.Fragment>
                                    ))}
                                    <Button size="sm" color="secondary"
                                        onClick={() => {
                                            template.addon_logic = [...(template.addon_logic || []), [{ addon_id: null, labels: [], is_not: false }]]
                                            update()
                                        }}
                                    >+ Add OR Clause</Button>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top"><Label>Depends On</Label></td>
                                <td>
                                    <div style={{ 'display': 'flex', 'flexWrap': 'wrap', 'gap': '6px', 'marginBottom': '8px' }}>
                                        {template.dependency.map((depId, i) => {
                                            const label = depId === null
                                                ? 'Start'
                                                : (() => {
                                                    const dep = savedTypeTemplates.find(t => t.id === depId)
                                                    if (!dep) return null
                                                    return [dep.short_description, dep.equip, dep.process].filter(Boolean).join(' - ')
                                                })()
                                            if (label === null) return null
                                            return (
                                                <span key={depId ?? '__start__'} className="badge bg-secondary d-inline-flex align-items-center gap-1">
                                                    {label}
                                                    <button type="button"
                                                        onClick={() => { template.dependency = template.dependency.filter((_, j) => j !== i); update() }}
                                                        style={{ 'background': 'none', 'border': 'none', 'cursor': 'pointer', 'padding': '0', 'lineHeight': 1, 'color': 'inherit' }}
                                                    >×</button>
                                                </span>
                                            )
                                        })}
                                    </div>
                                    {(!template.dependency.includes(null) || savedTypeTemplates.filter(t => !template.dependency.includes(t.id)).length > 0) &&
                                        <Input type="select" value=""
                                            onChange={(e) => {
                                                if (e.target.value) {
                                                    const val = e.target.value === '__start__' ? null : e.target.value
                                                    template.dependency = [...template.dependency, val]
                                                    update()
                                                }
                                            }}
                                        >
                                            <option value="">Add dependency…</option>
                                            {!template.dependency.includes(null) &&
                                                <option value="__start__">Start</option>
                                            }
                                            {savedTypeTemplates
                                                .filter(t => !template.dependency.includes(t.id))
                                                .map(t => {
                                                    const label = [t.short_description, t.equip, t.process].filter(Boolean).join(' - ')
                                                    return <option key={t.id} value={t.id}>{label}</option>
                                                })
                                            }
                                        </Input>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </td>
            </tr>}
        </React.Fragment>
    }

    bulkApply() {
        const { bulkEquip, bulkProcess, bulkFormula, templates } = this.state
        if (!bulkEquip || !bulkFormula) return
        const matching = templates.filter(t =>
            t.equip === bulkEquip &&
            (bulkProcess === 'All' || t.process === bulkProcess)
        )
        matching.forEach(t => {
            t.time_formula = bulkFormula
            this.updateTemplate(t)
        })
        this.setState({ templates: [...templates] })
    }

    renderBulkUpdate() {
        const { bulkEquip, bulkProcess, bulkFormula, templates } = this.state
        const processOptions = ['All', ...(EQUIPMENT_PROCESSES[bulkEquip] || [])]
        const matchCount = bulkEquip
            ? templates.filter(t =>
                t.equip === bulkEquip &&
                (bulkProcess === 'All' || t.process === bulkProcess)
            ).length
            : 0

        return (
            <div style={{ marginBottom: '32px', padding: '16px', border: '1px solid var(--bs-border-color)', borderRadius: '6px' }}>
                <Label style={{ fontSize: '18px', fontWeight: '600', display: 'block', marginBottom: '12px' }}>
                    Bulk Update Time Formula
                </Label>
                <Row className="align-items-end" style={{ gap: '8px 0' }}>
                    <Col md="2">
                        {this.renderDropDown('Equipment', bulkEquip || '—', ['—', ...EQUIPMENT_LIST], (v) => {
                            this.setState({ bulkEquip: v === '—' ? '' : v, bulkProcess: 'All' })
                        })}
                    </Col>
                    <Col md="3">
                        {this.renderDropDown('Process', bulkProcess, processOptions, (v) => {
                            this.setState({ bulkProcess: v })
                        })}
                    </Col>
                    <Col md="5">
                        <Label>Time Formula</Label>
                        <Input
                            value={bulkFormula}
                            placeholder="e.g. ((width*2 + height*2) * 30 + 60*3) * quantity"
                            onChange={(e) => this.setState({ bulkFormula: e.target.value })}
                        />
                    </Col>
                    <Col md="2">
                        <Label style={{ display: 'block', fontSize: '12px', opacity: 0.7 }}>
                            {bulkEquip ? `${matchCount} template${matchCount !== 1 ? 's' : ''} will be updated` : ' '}
                        </Label>
                        <Button
                            color="warning"
                            disabled={!bulkEquip || !bulkFormula}
                            onClick={() => this.bulkApply()}
                        >Apply</Button>
                    </Col>
                </Row>
            </div>
        )
    }

    renderMaterialTemplateSection(type, typeAddons) {
        const update = () => this.setState({})
        const typeMTs = this.state.materialTemplates
            .filter(mt => mt.type_id === type.id)
            .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))

        return <div style={{ 'marginBottom': '20px' }}>
            <Label style={{ 'fontSize': '16px', 'fontWeight': '600', 'display': 'block', 'marginBottom': '6px' }}>
                Material / Thickness Config
            </Label>
            <Table>
                <thead>
                    <tr>
                        <th>Material</th>
                        <th>Thickness</th>
                        <th></th>
                        <th>Save</th>
                        <th>Copy</th>
                        <th>Delete</th>
                        <th>Order</th>
                    </tr>
                </thead>
                <tbody>
                    {typeMTs.map((mt, i) => {
                        const isExpanded = this.state.expandedMaterialTemplates.includes(mt)
                        const isSaved = !!mt.id && !mt.is_local
                        return <React.Fragment key={mt.id || mt._local_key}>
                            <tr>
                                <td style={{ 'width': '30%' }}>
                                    {this.renderDropDown('Material', mt.material, MATERIAL_VALUES, v => { mt.material = v; update() })}
                                </td>
                                <td style={{ 'width': '20%' }}>
                                    {this.renderDropDown('Thickness', mt.thickness, THICKNESS_VALUES, v => { mt.thickness = v; update() })}
                                </td>
                                <td>
                                    <Button onClick={() => {
                                        if (isExpanded) {
                                            this.setState((s) => ({ 'expandedMaterialTemplates': s.expandedMaterialTemplates.filter(x => x !== mt) }))
                                        } else {
                                            this.setState((s) => ({ 'expandedMaterialTemplates': [...s.expandedMaterialTemplates, mt] }))
                                        }
                                    }}>
                                        {isExpanded
                                            ? <IoIosArrowDown style={{ 'fontSize': '20pt' }} />
                                            : <IoIosArrowUp style={{ 'fontSize': '20pt' }} />
                                        }
                                    </Button>
                                </td>
                                <td>
                                    {mt.is_local
                                        ? <Button color="success" onClick={() => this.postMaterialTemplate(mt)}>Save New</Button>
                                        : <Button color="success" onClick={() => this.saveMaterialTemplate(mt)}>Update</Button>
                                    }
                                </td>
                                <td>
                                    <Button className="btn btn-copy" onClick={() => {
                                        const copy = JSON.parse(JSON.stringify(mt))
                                        copy.id = null
                                        copy.is_local = true
                                        copy._local_key = Date.now() + Math.random()
                                        copy.order_index = typeMTs.reduce((max, t) => Math.max(max, t.order_index || 0), -1) + 1
                                        this.setState((s) => ({
                                            'materialTemplates': [...s.materialTemplates, copy],
                                            'expandedMaterialTemplates': [...s.expandedMaterialTemplates, copy],
                                        }))
                                    }}>Copy</Button>
                                </td>
                                <td>
                                    <Button color="danger" disabled={!isSaved} onClick={() => this.deleteMaterialTemplate(mt)}>Delete</Button>
                                </td>
                                <td>
                                    <div style={{ 'display': 'flex', 'flexDirection': 'column', 'gap': '2px' }}>
                                        <Button size="sm" disabled={!isSaved || i === 0 || !typeMTs[i - 1]?.id}
                                            onClick={() => this.swapMaterialTemplates(typeMTs, i, i - 1)}>
                                            <IoIosArrowUp style={{ 'fontSize': '10pt' }} />
                                        </Button>
                                        <Button size="sm" disabled={!isSaved || i === typeMTs.length - 1 || !typeMTs[i + 1]?.id}
                                            onClick={() => this.swapMaterialTemplates(typeMTs, i, i + 1)}>
                                            <IoIosArrowDown style={{ 'fontSize': '10pt' }} />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                            {isExpanded && <tr>
                                <td colSpan="7" style={{ 'padding': '0 12px 16px 32px' }}>
                                    <Table size="sm" borderless style={{ 'tableLayout': 'fixed' }}>
                                        <colgroup>
                                            <col style={{ 'width': '130px' }} />
                                            <col />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <td valign="top"><Label>Required Addons</Label></td>
                                                <td>
                                                    <small style={{ 'color': '#888', 'display': 'block', 'marginBottom': '6px' }}>
                                                        All listed addons must be present on the sign (AND logic). Empty labels = any label for that addon.
                                                    </small>
                                                    <div style={{ 'display': 'flex', 'flexWrap': 'wrap', 'gap': '6px', 'marginBottom': '8px' }}>
                                                        {(mt.addons || []).map((entry, ai) => {
                                                            const addon = typeAddons.find(a => a.id === entry.addon_id)
                                                            const addonLabel = addon ? addon.cost_label : entry.addon_id
                                                            const labelSuffix = (entry.labels || []).length > 0
                                                                ? ': ' + entry.labels.join(', ')
                                                                : ''
                                                            return <span key={ai} className="badge bg-secondary d-inline-flex align-items-center gap-1">
                                                                {addonLabel}{labelSuffix}
                                                                <button type="button"
                                                                    onClick={() => { mt.addons = mt.addons.filter((_, j) => j !== ai); update() }}
                                                                    style={{ 'background': 'none', 'border': 'none', 'cursor': 'pointer', 'padding': '0', 'lineHeight': 1, 'color': 'inherit' }}
                                                                >×</button>
                                                            </span>
                                                        })}
                                                    </div>
                                                    {typeAddons.filter(a => !(mt.addons || []).some(e => e.addon_id === a.id)).length > 0 &&
                                                        <Input type="select" value=""
                                                            onChange={(e) => {
                                                                if (e.target.value) {
                                                                    mt.addons = [...(mt.addons || []), { addon_id: e.target.value, labels: [] }]
                                                                    update()
                                                                }
                                                            }}
                                                        >
                                                            <option value="">Add addon requirement…</option>
                                                            {typeAddons
                                                                .filter(a => !(mt.addons || []).some(e => e.addon_id === a.id))
                                                                .map(a => <option key={a.id} value={a.id}>{this.addonDropdownLabel(a)}</option>)
                                                            }
                                                        </Input>
                                                    }
                                                    {(mt.addons || []).map((entry, ai) => {
                                                        const addon = typeAddons.find(a => a.id === entry.addon_id)
                                                        const availLabels = this.addonOptionGroups(addon)
                                                        if (availLabels.length === 0) return null
                                                        return <div key={ai} style={{ 'marginTop': '10px' }}>
                                                            <small style={{ 'color': '#888', 'display': 'block', 'marginBottom': '2px' }}>
                                                                {addon?.cost_label} labels (empty = any):
                                                            </small>
                                                            {availLabels.map(label => (
                                                                <Label key={label} check style={{ 'cursor': 'pointer', 'display': 'block' }}>
                                                                    <Input type="checkbox"
                                                                        checked={(entry.labels || []).includes(label)}
                                                                        onChange={() => {
                                                                            entry.labels = (entry.labels || []).includes(label)
                                                                                ? entry.labels.filter(l => l !== label)
                                                                                : [...(entry.labels || []), label]
                                                                            update()
                                                                        }}
                                                                    />{' '}{label}
                                                                </Label>
                                                            ))}
                                                        </div>
                                                    })}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>}
                        </React.Fragment>
                    })}
                    <tr>
                        <td colSpan="7">
                            <Button color="primary" onClick={() => {
                                const mt = {
                                    type_id: type.id,
                                    addons: [],
                                    material: '',
                                    thickness: '',
                                    order_index: typeMTs.reduce((max, t) => Math.max(max, t.order_index || 0), -1) + 1,
                                    is_local: true,
                                    _local_key: Date.now() + Math.random(),
                                }
                                this.setState((s) => ({
                                    'materialTemplates': [...s.materialTemplates, mt],
                                    'expandedMaterialTemplates': [...s.expandedMaterialTemplates, mt],
                                }))
                            }}>Add Material Config</Button>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    }

    renderTypeSection(type) {
        const isExpanded = this.state.minimizeTypes.includes(type.id)
        // Include global addons (type_id = null) alongside type-specific ones
        const typeAddons = this.state.addons
            .filter(a => a.type_id === type.id || a.type_id == null)
            .sort((a, b) => a.cost_label.localeCompare(b.cost_label))
        const typeTemplates = this.state.templates
            .filter(t => t.type_id === type.id)
            .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))

        return <div key={type.id} style={{ 'marginBottom': '24px' }}>
            <Label style={{ 'fontSize': '28px', 'fontWeight': '550' }}>{type.label}</Label>
            <Button
                style={{ 'marginLeft': '12px' }}
                onClick={() => {
                    if (isExpanded) {
                        this.setState((s) => ({ 'minimizeTypes': s.minimizeTypes.filter(id => id !== type.id) }))
                    } else {
                        this.setState((s) => ({ 'minimizeTypes': [...s.minimizeTypes, type.id] }))
                    }
                }}
            >
                {isExpanded
                    ? <IoIosArrowDown style={{ 'fontSize': '20pt' }} />
                    : <IoIosArrowUp style={{ 'fontSize': '20pt' }} />
                }
            </Button>

            {isExpanded && <div style={{ 'padding': '12px 0 0 20px' }}>
                {this.renderMaterialTemplateSection(type, typeAddons)}
                <Table>
                    <thead>
                        <tr>
                            <th style={{ 'minWidth': '200px' }}>Description</th>
                            <th></th>
                            <th>Save</th>
                            <th>Copy</th>
                            <th>Delete</th>
                            <th>Order</th>
                        </tr>
                    </thead>
                    <tbody>
                        {typeTemplates.map((t, i) => this.renderTemplate(t, typeAddons, typeTemplates, i))}
                        <tr>
                            <td colSpan="6">
                                <Button color="primary" onClick={() => {
                                    const t = ScheduleTemplate.from({ 'type_id': type.id })
                                    t.is_local = true
                                    t._local_key = Date.now() + Math.random()
                                    t.order_index = typeTemplates.reduce((max, t) => Math.max(max, t.order_index || 0), -1) + 1
                                    this.setState((s) => ({
                                        'templates': [...s.templates, t],
                                        'expandedTemplates': [...s.expandedTemplates, t],
                                    }))
                                }}>Add Template</Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                {this.renderFlowChartToggle(type, typeTemplates, typeAddons)}
            </div>}
        </div>
    }

    renderFlowChartToggle(type, typeTemplates, typeAddons) {
        const isFlowChartOpen = this.state.openFlowCharts.includes(type.id)

        return <div style={{ 'marginTop': '16px' }}>
            <Label style={{ 'fontSize': '20px', 'fontWeight': 'bold', 'marginRight': '12px' }}>Flow Chart</Label>
            <Button
                onClick={() => {
                    if (isFlowChartOpen) {
                        this.setState((s) => ({ 'openFlowCharts': s.openFlowCharts.filter(id => id !== type.id) }))
                    } else {
                        this.setState((s) => ({ 'openFlowCharts': [...s.openFlowCharts, type.id] }))
                    }
                }}
            >
                {isFlowChartOpen
                    ? <IoIosArrowDown style={{ 'fontSize': '20pt' }} />
                    : <IoIosArrowUp style={{ 'fontSize': '20pt' }} />
                }
            </Button>
            <Collapse isOpen={isFlowChartOpen}>
                <div style={{ 'paddingTop': '12px' }}>
                    <ScheduleTemplateFlowView templates={typeTemplates} addons={typeAddons} />
                </div>
            </Collapse>
        </div>
    }

    render() {
        return (
            <div style={{ 'margin': '22px' }}>
                <Label style={{ 'fontSize': '36px', 'fontWeight': '600', 'display': 'block', 'marginBottom': '24px' }}>
                    Schedule Template Builder
                </Label>
                {this.renderBulkUpdate()}
                {this.state.types.map(type => this.renderTypeSection(type))}
            </div>
        )
    }
}

export { ScheduleTemplateBuilderViewController }
